import { reviewConstants } from './constants/reviewConstants';


export const getSchoolByRatings = (data:any) => ({
  type: reviewConstants.getSchoolByRatingsRequest,
  payload: data
}); 

const listReviewsRequest = (params: any) => ({
  type: reviewConstants.listReviewsRequest,
  payload: params,
});

const getInstructorRatingsRequest = (instructorId: string) => ({
  type: reviewConstants.getInstructorRatingsRequest,
  payload: { instructorId },
});

const getSchoolRatingsRequest = (params?: any) => ({
  type: reviewConstants.getSchoolRatingsRequest,
  payload: params,
});

const deleteReviewRequest = (id: string) => ({
  type: reviewConstants.deleteReviewRequest,
  payload: { id },
});

const viewReviewRequest = (id: string) => ({
  type: reviewConstants.viewReviewRequest,
  payload: { id },
});

export const reviewActions = {
  listReviewsRequest,
  getInstructorRatingsRequest,
  getSchoolRatingsRequest,
  deleteReviewRequest,
  viewReviewRequest,
  getSchoolByRatings
};
